// @ts-ignore-error
import FormFieldWrapper from '@plone/volto/components/manage/Widgets/FormFieldWrapper';
import { Button, Grid } from 'semantic-ui-react';

export interface sizeWidgetProps {
  onChange: (id: string, value: string) => void;
  id: string;
  choices: string[];
  value: string;
}

const sizeWidget = (props: sizeWidgetProps) => {
  const { onChange, choices, id, value } = props;
  return (
    <FormFieldWrapper {...props}>
      <Grid>
        <Grid.Row>
          <Grid.Column width="8" className="field-image_size">
            {choices.map((opt) => (
              <Button.Group key={opt}>
                <Button
                  icon
                  basic
                  aria-label={opt}
                  onClick={() => onChange(id, opt)}
                  active={value === opt}
                >
                  <div>{opt}</div>
                </Button>
              </Button.Group>
            ))}
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </FormFieldWrapper>
  );
};

export default sizeWidget;
